<template>
  <div class="addEdit-block">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" class="detail-form-content">
      <el-row>
        <el-col :span="12">
          <el-form-item label="字段标签" prop="fieldLabel">
            <el-input v-model="ruleForm.fieldLabel" placeholder="请输入字段标签（如：姓名）" @blur="generateFieldName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="字段类型" prop="fieldType">
            <el-select v-model="ruleForm.fieldType" placeholder="请选择字段类型">
              <el-option label="文本输入" value="text"></el-option>
              <el-option label="多行文本" value="textarea"></el-option>
              <el-option label="数字" value="number"></el-option>
              <el-option label="下拉选择" value="select"></el-option>
              <el-option label="单选" value="radio"></el-option>
              <el-option label="多选" value="checkbox"></el-option>
              <el-option label="日期" value="date"></el-option>
              <el-option label="手机号" value="phone"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24"
          v-show="ruleForm.fieldType === 'select' || ruleForm.fieldType === 'radio' || ruleForm.fieldType === 'checkbox'">
          <el-form-item label="选项值" prop="options">
            <div class="options-list">
              <div v-for="(opt, index) in optionItems" :key="index" class="option-item">
                <el-input v-model="optionItems[index]" placeholder="请输入选项值" style="width: 150px;"
                  @blur="syncOptions"></el-input>
                <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeOption(index)"
                  :disabled="optionItems.length <= 1"></el-button>
              </div>
              <el-button type="primary" icon="el-icon-plus" size="mini" @click="addOption"
                style="margin-top: 8px;">添加选项</el-button>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否必填" prop="required">
            <el-radio-group v-model="ruleForm.required">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序" prop="sorts">
            <el-input v-model.number="ruleForm.sorts" type="number" placeholder="排序数字，越小越靠前"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否启用" prop="status">
            <el-radio-group v-model="ruleForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="btn">
        <el-button type="primary" class="btn-success" @click="submitForm('ruleForm')">确定</el-button>
        <el-button class="btn-close" @click="cancel">取消</el-button>
      </el-form-item>
      <el-input v-model="ruleForm.fieldName" type="hidden"></el-input>
      <el-input v-model="ruleForm.formGroup" type="hidden"></el-input>
    </el-form>
  </div>
</template>

<script>
import pinyin from 'pinyin'

export default {
  name: 'FormFieldAddOrUpdate',
  data() {
    return {
      optionItems: [''],  // 动态选项列表，用于界面编辑
      ruleForm: {
        fieldLabel: '',
        fieldName: '',
        fieldType: 'text',
        options: '',
        required: 0,
        sorts: 0,
        status: 1,
        formGroup: 'yuyue'
      },
      rules: {
        fieldLabel: [
          { required: true, message: '请输入字段标签', trigger: 'blur' }
        ],
        fieldType: [
          { required: true, message: '请选择字段类型', trigger: 'change' }
        ]
      },
      id: null,
      type: null
    }
  },
  methods: {
    generateFieldName() {
      if (this.ruleForm.fieldLabel && !this.ruleForm.fieldName) {
        this.ruleForm.fieldName = this.convertToPinyin(this.ruleForm.fieldLabel);
      }
    },
    convertToPinyin(str) {
      // 使用 pinyin 库转换中文为拼音，不带声调，多音字取常用读音
      var result = pinyin(str, { style: pinyin.STYLE_NORMAL, heteronym: false }).join('');
      // 只保留小写字母和数字
      result = result.replace(/[^a-z0-9]/g, '');
      return result || 'field';
    },
    init(id, type) {
      this.id = id;
      this.type = type;
      this.optionItems = [''];
      // 使用 $set 确保 Vue 响应式正确追踪
      this.$set(this, 'ruleForm', {
        fieldLabel: '',
        fieldName: '',
        fieldType: 'text',
        options: '',
        required: 0,
        sorts: 0,
        status: 1,
        formGroup: 'yuyue'
      });
      if (id) {
        this.$http({
          url: "formField/info/" + id,
          method: "get"
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$set(this, 'ruleForm', data.data);
            // 把 options 字符串解析为数组供界面编辑
            if (data.data.options) {
              // 兼容逗号和换行两种分隔符
              var sep = data.data.options.indexOf(',') >= 0 ? ',' : '\n';
              this.optionItems = data.data.options.split(sep).filter(function (o) { return o.trim() !== ''; });
              if (this.optionItems.length === 0) {
                this.optionItems = [''];
              }
            } else {
              this.optionItems = [''];
            }
          }
        });
      }
    },
    // 添加一个选项
    addOption() {
      this.optionItems.push('');
    },
    // 删除一个选项
    removeOption(index) {
      if (this.optionItems.length > 1) {
        this.optionItems.splice(index, 1);
        this.syncOptions();
      }
    },
    // 把选项数组同步到 ruleForm.options 字符串（用逗号分隔）
    syncOptions() {
      var validItems = this.optionItems.filter(function (o) { return o.trim() !== ''; });
      this.ruleForm.options = validItems.join(',');
    },
    submitForm(formName) {
      this.syncOptions();  // 提交前先同步选项值
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.id) {
            this.$http({
              url: "formField/update",
              method: "post",
              data: this.ruleForm
            }).then(({ data }) => {
              if (data && data.code === 0) {
                this.$message.success('修改成功');
                this.$emit('refreshDataList');
                this.cancel();
              } else {
                this.$message.error(data.msg || '修改失败');
              }
            });
          } else {
            this.$http({
              url: "formField/add",
              method: "post",
              data: this.ruleForm
            }).then(({ data }) => {
              if (data && data.code === 0) {
                this.$message.success('新增成功');
                this.$emit('refreshDataList');
                this.cancel();
              } else {
                this.$message.error(data.msg || '新增失败');
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$emit('refreshDataList');
    }
  }
}
</script>
<style scoped>
.options-list {
  width: 100%;
}

.option-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.option-item .el-input {
  flex: 1;
}
</style>
